import React from 'react'
import styles from './styles'
import { withStyles } from '@material-ui/core/styles'

const Header = ({ classes, children, title = 'Supply Register' }) => <header className={classes.header}>
  <p className={classes.title}>
    {title}
  </p>
  {children}
</header>

export default withStyles(styles)(Header)
